define('lq/parameterCollection',[
    'underscore'
], function (_) {

    var getInternalKey = function (key) {
        // fallback to empty string for EPP
        return (key || '').toLowerCase();
    };

    var ParameterCollection = function (initialValues, parentCollection) {
        this.parameters = {};
        this.parentCollection = parentCollection;

        if (initialValues) {
            var self = this;
            _.each(_.keys(initialValues), function (key) {
                self.setValue(key, initialValues[key]);
            });
        }
    };
        
    ParameterCollection.prototype.getValue = function (key) {
        var entry = this.parameters[getInternalKey(key)];

        if (entry) {
            if (typeof entry.value === 'function')
                return entry.value();
            return entry.value;
        }

        if (this.parentCollection)
            return this.parentCollection.getValue(key);
        
        return undefined;
    };

    ParameterCollection.prototype.setValue = function (key, value) {
        if (!key) return;

        var internalKey = getInternalKey(key);

        if (this.parameters[internalKey])
            this.parameters[internalKey].value = value;
        else
            this.parameters[internalKey] = {
                key: key,
                value: value
            };
    };

    ParameterCollection.prototype.clear = function (key) {
        this.setValue(key, null);
    };

    ParameterCollection.prototype.remove = function (key) {
        delete this.parameters[getInternalKey(key)];
    };
    
    ParameterCollection.prototype.getAll = function () {
        return this.copyInto({});
    };

    ParameterCollection.prototype.copyInto = function (targetObject) {
        var self = this;
        _.each(_.keys(this.parameters), function (internalKey) {
            var originalKey = self.parameters[internalKey].key;
            var value = self.getValue(internalKey);
            targetObject[originalKey] = value;
        });

        if (this.parentCollection)
            return this.parentCollection.copyInto(targetObject);

        return targetObject;
    };

    ParameterCollection.prototype.createChildScope = function (initialValues) {
        return new ParameterCollection(initialValues, this);
    };

    return ParameterCollection;
});
